(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentCategoryAccessDetailController', AgentCategoryAccessDetailController);

    AgentCategoryAccessDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'AgentCategoryAccess', 'AgentAccessInfo', 'ServiceCategory'];

    function AgentCategoryAccessDetailController($scope, $rootScope, $stateParams, entity, AgentCategoryAccess, AgentAccessInfo, ServiceCategory) {
        var vm = this;

        vm.agentCategoryAccess = entity;

        var unsubscribe = $rootScope.$on('tikonApp:agentCategoryAccessUpdate', function (event, result) {
            vm.agentCategoryAccess = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
